import React from 'react';
import { useRecoilValue } from 'recoil';
import { useHistory } from 'react-router-dom';

import { ReactComponent as ShippingIcon } from 'assets/svg/shipping.svg';
import { ReactComponent as BillingIcon } from 'assets/svg/billing.svg';
import { ReactComponent as ReviewIcon } from 'assets/svg/review.svg';
import { ReactComponent as DoneIcon } from 'assets/svg/done.svg';

import { checkoutState } from 'state/atoms';
import {
  CHECKOUT_SHIPPING_STEP,
  CHECKOUT_BILLING_STEP,
  CHECKOUT_REVIEW_STEP,
  CHECKOUT_CONFIRMATION_STEP,
  CHECKOUT_STEP_SEQUENCE,
} from 'utils/constants';

import { StepsWrapper, Step, StepContent } from './styledComponents';

const ProgressTracker = () => {
  const { currentStep } = useRecoilValue(checkoutState);

  const history = useHistory();

  const renderStep = ({
    Icon,
    content,
    hoverContent,
    url,
    step,
    arrowRight = true,
    clickable = true,
  }) => {
    const completed =
      CHECKOUT_STEP_SEQUENCE.indexOf(currentStep) >
      CHECKOUT_STEP_SEQUENCE.indexOf(step);

    return (
      <Step onClick={() => completed && clickable && history.push(url)}>
        <StepContent
          arrowRight={arrowRight}
          completed={completed}
          active={currentStep === step}
          clickable={clickable}
          hoverable={hoverContent}
        >
          <Icon />
          <span className="progress-tracker-content">{content}</span>
          {hoverContent && (
            <span className="progress-tracker-content-hover">
              {hoverContent}
            </span>
          )}
        </StepContent>
      </Step>
    );
  };

  return (
    <StepsWrapper>
      {renderStep({
        step: CHECKOUT_SHIPPING_STEP,
        Icon: ShippingIcon,
        content: 'Shipping',
        url: '/cases/new/checkout/shipping',
      })}
      {renderStep({
        step: CHECKOUT_BILLING_STEP,
        Icon: BillingIcon,
        content: 'Billing',
        url: '/cases/new/checkout/billing',
      })}
      {renderStep({
        step: CHECKOUT_REVIEW_STEP,
        Icon: ReviewIcon,
        content: 'RMA Review',
        url: '/cases/new/checkout/review',
      })}
      {renderStep({
        step: CHECKOUT_CONFIRMATION_STEP,
        Icon: DoneIcon,
        content: 'Confirmation',
        url: '/cases/new/checkout/confirmation',
        arrowRight: false,
      })}
    </StepsWrapper>
  );
};

export { ProgressTracker };
